import { createFileRoute } from "@tanstack/react-router";
import ResponsiveListsPage from "@/pages/dev/ResponsiveListsPage";

export const Route = createFileRoute("/dev/responsive-lists")({
  component: ResponsiveListsPage,
});
